<template>
    <el-col 
        :span="8" 
        :key="index" 
        style="margin-top: 6px; margin-bottom: 24px"
    >
        <h2>{{ equipment_based_plan.name }}</h2>
        <template>
            <p>Available: {{ equipment_based_plan.estimate }} at {{ money(equipment_based_plan.price) }}/each</p>

            <el-radio-group :value="radioValue" @input="setJaLeads">
                <div v-for="(leads, index) in radioOptions" :key="index">
                    <el-radio :label="leads">{{ leadsPlanName(leads, equipment_based_plan.price) }}
                    </el-radio><br>
                </div>
                <div>
                    <el-radio label="custom">
                        <el-input v-model="customLeads" style="width: 100px;" /> leads
                        <template v-if="customLeads">
                            (+ {{ money(parseInt(customLeads) * equipment_based_plan.price, 0) }})
                        </template>
                    </el-radio><br>
                </div>
            </el-radio-group>
        </template>
    </el-col>
</template>

<script>
export default {
    props: {
        equipment_based_plan: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            customLeads: this.equipment_based_plan.leads,
            radioOptions: [0,10,15,20,25,50,100,125,175,200,250],
        }
    },
    watch: {
        customLeads() {
            this.setJaLeads('custom');
        },
    },
    computed: {
        radioValue() {
            return (this.radioOptions.includes(this.equipment_based_plan.leads))
              ? this.equipment_based_plan.leads
              : 'custom';
        },
    },
    methods: {
        setJaLeads(value) {
            if (value == 'custom') {
                this.equipment_based_plan.leads = parseInt(this.customLeads) || 0;
            }
            else {
                this.equipment_based_plan.leads = value;
            }
        },
        leadsPlanName(leads, price) {
            return leads ? leads+' leads (+'+this.money(leads * price, 0)+')' : 'no Driver Boost';
        },
    }
}
</script>